"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactMultiCarousel = _interopRequireDefault(require("react-multi-carousel"));
var _AnimatedArrow = _interopRequireDefault(require("./AnimatedArrow"));
var _CustomCard = _interopRequireDefault(require("./CustomCard"));
var _SearchComponent = _interopRequireDefault(require("./SearchComponent"));
var _Helpers = require("./Helpers");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _pressreleaseModule = _interopRequireDefault(require("./css/pressrelease.module.css"));
var _fancyModule = _interopRequireDefault(require("./css/fancy.module.css"));
var _searchBoxModule = _interopRequireDefault(require("./css/searchBox.module.css"));
var _carouselModule = _interopRequireDefault(require("./css/carousel.module.css"));
require("react-multi-carousel/lib/styles.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PressRelease = _ref => {
  let {
    pressReleaseTitle,
    pressReleaseList
  } = _ref;
  const [currentPressReleaseList, setCurrentPressReleaseList] = (0, _react.useState)(pressReleaseList);
  const [originalPressReleaseList, setOriginalPressReleaseList] = (0, _react.useState)(pressReleaseList);
  const [clickPosition, setClickPosition] = (0, _react.useState)(0);
  const [selectedLender, setSelectedLender] = (0, _react.useState)();
  const [showPressReleaseModal, setShowPressReleaseModal] = (0, _react.useState)(false);
  const showAlertDetail = ele => {
    setSelectedLender(ele);
    setShowPressReleaseModal(true);
  };
  const redirectToMainPage = ele => {
    window.open(ele.redirectURL, "_blank");
  };
  const hidePressReleaseModal = () => {
    setShowPressReleaseModal(false);
  };
  const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 4,
      slidesToSlide: 1
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 766
      },
      items: 3,
      slidesToSlide: 1
    },
    mobile: {
      breakpoint: {
        max: 765,
        min: 0
      },
      items: 1,
      slidesToSlide: 1
    }
  };
  (0, _react.useEffect)(() => {
    setOriginalPressReleaseList(pressReleaseList);
    setCurrentPressReleaseList(pressReleaseList);
  }, [pressReleaseList]);
  const onSearch = e => {
    const textSearched = e.target.value;
    let newList = currentPressReleaseList;
    if (textSearched && currentPressReleaseList.filter(element => element.title.toLowerCase().indexOf(textSearched.toLowerCase()) !== -1).length > 0) {
      newList = textSearched ? currentPressReleaseList.filter(element => element.title.toLowerCase().indexOf(textSearched.toLowerCase()) !== -1) : currentPressReleaseList;
    } else {
      newList = originalPressReleaseList;
    }
    setCurrentPressReleaseList(newList);
  };
  const ButtonGroup = _ref2 => {
    let {
      next,
      previous
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${_carouselModule.default["carousel-button-group"]} position-relative d-flex justify-content-between align-items-center`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `custom-btn ${_carouselModule.default["slider-custom-arrows"]} ${_carouselModule.default["arrow-left"]}`,
      onClick: () => previous()
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://prod-cdn.swmc.com/swmc-common/images/Pavan/arrow_blue_left.svg",
      className: "img-fluid",
      alt: "previous-button"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: `custom-btn ${_carouselModule.default["slider-custom-arrows"]} ${_carouselModule.default["arrow-right"]}`,
      onClick: () => next()
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://prod-cdn.swmc.com/swmc-common/images/Pavan/arrow_blue_right.svg",
      className: "img-fluid",
      alt: "next-button"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _pressreleaseModule.default["press-release-parent"]
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: `press-release-container ${_pressreleaseModule.default["press-release-container"]}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _pressreleaseModule.default["search-box-parent"]
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: `${_fancyModule.default["curved_white_top_border"]}`
  }, pressReleaseTitle), /*#__PURE__*/_react.default.createElement(_AnimatedArrow.default, null), /*#__PURE__*/_react.default.createElement(_SearchComponent.default, {
    searchBoxClassName: `${_searchBoxModule.default.searchBox}`,
    searchIconClassName: `${_searchBoxModule.default.searchIcon}`,
    onSearch: onSearch
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _carouselModule.default["custom-carousel-wrapper"]
  }, /*#__PURE__*/_react.default.createElement(_reactMultiCarousel.default, {
    swipeable: true,
    draggable: true,
    showDots: false,
    responsive: responsive,
    ssr: true // means to render carousel on server-side.
    ,
    infinite: false,
    autoPlaySpeed: 20000,
    keyBoardControl: true,
    containerClass: `${_carouselModule.default["carousel-container"]}`,
    dotListClass: `${_carouselModule.default["custom-dot-list-style"]}`,
    itemClass: `${_carouselModule.default["custom-carousel-item"]}`,
    sliderClass: `${_carouselModule.default["custom-slider"]}`,
    customTransition: "transform 100ms linear",
    renderButtonGroupOutside: true,
    customButtonGroup: /*#__PURE__*/_react.default.createElement(ButtonGroup, null)
  }, currentPressReleaseList.map((item, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: "100%"
    },
    key: index
  }, item.redirectURL ? /*#__PURE__*/_react.default.createElement(_CustomCard.default, {
    titleFirst: false,
    cardContainerClassName: `${_carouselModule.default["card-container"]}`,
    titleClassName: `${_carouselModule.default["card-title"]}`,
    titleContent: item.title,
    imageClassName: `${_carouselModule.default["card-image"]}`,
    imageProps: {
      src: item.companyLogo ? item.companyLogo : "https://resources.swmc.com/images/press-release/market_watch.svg",
      fluid: true,
      alt: "decorative ellipse",
      width: "200px",
      height: "600px"
    },
    onMouseDown: e => {
      setClickPosition(e.clientX);
    },
    onMouseUp: e => (0, _Helpers.handleMouseUp)(e, clickPosition, () => redirectToMainPage(item))
  }) : /*#__PURE__*/_react.default.createElement(_CustomCard.default, {
    titleFirst: false,
    cardContainerClassName: `${_carouselModule.default["card-container"]}`,
    titleClassName: `${_carouselModule.default["card-title"]}`,
    titleContent: item.title,
    imageClassName: `${_carouselModule.default["card-image"]}`,
    imageProps: {
      src: "https://resources.swmc.com/images/press-release/market_watch.svg",
      fluid: true,
      alt: "decorative ellipse",
      width: "200px",
      height: "600px"
    },
    onMouseDown: e => {
      setClickPosition(e.clientX);
    },
    onMouseUp: e => (0, _Helpers.handleMouseUp)(e, clickPosition, () => showAlertDetail(item))
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _carouselModule.default["date"]
  }, (0, _Helpers.FormatChanger)(item.date))))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    className: `${_pressreleaseModule.default["dot-matrix"]} ${_pressreleaseModule.default["dot-matrix-left"]}`,
    src: "https://resources.swmc.com/images/press-release/dot_matrix_2.svg",
    fluid: true,
    alt: "dot-matrix icon",
    width: "50px",
    height: "70px"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    className: `${_pressreleaseModule.default["dot-matrix"]} ${_pressreleaseModule.default["dot-matrix-right"]}`,
    src: "https://resources.swmc.com/images/press-release/dot_matrix_2.svg",
    fluid: true,
    alt: "dot-matrix icon",
    width: "50px",
    height: "70px"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    size: "lg",
    centered: true,
    show: showPressReleaseModal,
    onHide: hidePressReleaseModal
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, selectedLender && selectedLender.content ? (0, _htmlReactParser.default)(selectedLender.content) : "")));
};
var _default = exports.default = PressRelease;